import React from 'react';
import TeamBadge, { pickTeamLogo } from './TeamBadge';

/** Team name with optional crest (from API teamLogo / teamLogoProxy). */
export default function TeamCell({ row, name, size = 20 }) {
  const team = name ?? row?.team ?? '';
  return (
    <span className="flex items-center gap-2 min-w-0">
      <TeamBadge name={team} logoUrl={pickTeamLogo(row)} size={size} />
      <span className="truncate">{team}</span>
    </span>
  );
}
